<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="info"
          icon="mdi-account-multiple"
          title="Total kunder"
          :value="customer_count+''"
          sub-icon="mdi-clock"
          :sub-text="customer_count_update_time_string"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="info"
          icon="mdi-tag"
          title="SDR x 8.33"
          :value="(sdrRate*8.33).toFixed(2)"
          :sub-text="`Dagsrate (${sdrRate})`"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'DashboardDashboard',

    data () {
      return {
        customer_count: 0,
        last_customer_update: null,
        now: Date.now(),
        sdrRate: 0,
        socket_connections: [
          { channel: 'panel.customer.count', event: 'increment', model: 'customer' },
          { channel: 'panel.customer.count', event: 'decrement', model: 'customer' },
        ],
      }
    },
    computed: {
      customer_count_update_time_string: function () {
        const duration = this.$moment.duration(-this.$moment(this.now).diff(this.$moment(this.last_customer_update)))

        return this.$moment.duration(duration, 'minutes').humanize(true)
      },
    },
    created: function () {
      setInterval(() => {
        this.now = Date.now()
      }, 1000)

      this.getCustomersCount()
      this.getSDRRate()

      this.socket_connections.forEach(sc => {
        this.$echo.private(`${sc.channel}`)
          .listen(`.${sc.event}`, (data) => {
            switch (sc.event) {
              case 'increment':
                this[`${sc.model}_count`]++
                this[`last_${sc.model}_update`] = Date.now()
                break
              case 'decrement':
                this[`${sc.model}_count`]--
                this[`last_${sc.model}_update`] = Date.now()
                break
              default:
                break
            }
          })
      })
    },
    destroyed: function () {
      this.socket_connections.forEach(sc => {
        this.$echo.private(sc.channel)
          .stopListening(`.${sc.event}`)
      })
    },
    methods: {
      getCustomersCount () {
        this.$get('/customers/count').then(r => {
          this.customer_count = r.data.data
          this.last_customer_update = Date.now()
        })
      },
      getSDRRate () {
        this.$get('/cs/sdr').then(r => {
          this.sdrRate = r.data.data
        })
      },
    },
  }
</script>
